import { GAUtil } from '../google-analytics';
import { GAEventAction, GAEventCategory, GTMUtils } from '../google-tag-manager';

export interface WindowWithNotificationService extends Window {
    DWSNotificationServiceInstance: NotificationApiService;
}

export class NotificationApiService {

    public static id = 'DWSNotificationServiceInstance';

    /**
     * Get NotificationApiService instance
     */
    public static getInstance(): NotificationApiService {
        const windowInstance = this.getGlobalInstance();

        if (windowInstance) {
            return windowInstance;
        }

        if (!this.instance) {
            try {
                this.instance = new NotificationApiService();
                (window as WindowWithNotificationService & typeof globalThis)
                    .DWSNotificationServiceInstance = this.instance;
            } catch (e) {
                console.info((<Error> e).message);
            }
        }

        return this.instance;
    }

    public static isNotificationApiAvailable(): boolean {
        try {
            return !!Notification;
        } catch(err) {
            return false;
        }
    }

    private static instance: NotificationApiService;

    /**
     * Retrieve instance from Window DOM interface
     */
    private static getGlobalInstance(): NotificationApiService | undefined {
        const win: WindowWithNotificationService = window as WindowWithNotificationService & typeof globalThis;

        if (!win) {
            return undefined;
        }

        if (win[NotificationApiService.id] === undefined) {
            return undefined;
        }

        return win[NotificationApiService.id];
    }

    /**
     * Service CTOR
     */
    public constructor() {
        if (!('Notification' in window)) {
            throw new Error('Notification API not available');
        }
    }

    public async triggerPermissionDialog(): Promise<NotificationPermission> {
        GTMUtils.pushCustomEventToDataLayer({
            category: GAEventCategory.PWA,
            action: GAEventAction.PWAPermissionRequest
        });
        const permissionResult: NotificationPermission = await Notification.requestPermission();

        if (permissionResult !== undefined) {
            GTMUtils.pushCustomEventToDataLayer({
                category: GAEventCategory.PWA,
                action: GAEventAction.PWAPermissionsChanged,
                label: permissionResult
            });
        }

        if (permissionResult !== 'granted') {
            throw new Error('We weren\'t granted permission for notifications.');
        }

        return permissionResult;
    }
}
